import {
  NotificationIcon,
  IconWrapper,
  NotificationNewIcon,
} from "common/components/icon";
import { HeaderButtonContainer } from "../../Wrapper/headerButton";
import styled from "styled-components";
import { useEffect, useRef, useState } from "react";
import { NotificationPanel } from "./NotificationPanel";

export const HeaderNotificationButton = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [isReceivedNew, setIsReceivedNew] = useState(false);
  const containerRef = useRef(null);

  // 마운트 시 플래그 확인
  useEffect(() => {
    const shouldOpen = localStorage.getItem("open-notification-panel");
    if (shouldOpen) {
      localStorage.removeItem("open-notification-panel");
      setIsOpen(true);
    }
  }, []);

  useEffect(() => {
    const handler = () => {
      setIsReceivedNew(!isOpen);
    };

    const openPanelHandler = () => {
      // 플래그 저장 후 reload
      localStorage.setItem("open-notification-panel", "true");
      window.location.reload();
    };

    window.addEventListener("sse-message", handler);
    window.addEventListener("open-notification-panel", openPanelHandler);

    // 클린업
    return () => {
      window.removeEventListener("sse-message", handler);
      window.removeEventListener("open-notification-panel", openPanelHandler);
    };
  }, []);

  return (
    <NotificationWrapper ref={containerRef}>
      <HeaderButtonContainer
        onClick={() => {
          setIsOpen(!isOpen);
          setIsReceivedNew(false);
        }}>
        <IconWrapper size={"1.5rem"} style={{ cursor: "pointer" }}>
          {isReceivedNew ? <NotificationNewIcon /> : <NotificationIcon />}
        </IconWrapper>
      </HeaderButtonContainer>
      {isOpen && <NotificationPanel onClose={() => setIsOpen(false)} />}
    </NotificationWrapper>
  );
};

const NotificationWrapper = styled.div`
  position: relative;
`;
